import regexParser from "regex-parser";
function matchOneStringRegex(value, regexes) {
    for (const stringRegex of regexes) {
        if (matchStringRegex(value, stringRegex)) {
            return true;
        }
    }
    return false;
}
function matchStringRegex(value, stringRegex) {
    const regex = regexParser(stringRegex);
    const match = value.match(regex);
    return match != null;
}
function getStringRegexMatches(value, stringRegex) {
    const regex = regexParser(stringRegex);
    const matches = getStringRegexMatchOrCaptures(value, "", regex);
    if (matches != null) {
        if (regex.flags.includes("g")) {
            return {
                singleMatch: null,
                globalMatch: matches.map((match) => match.hasGroups ? match.values.slice(1) : match.values[0]),
            };
        }
        else {
            return {
                singleMatch: matches[0].hasGroups ? matches[0].values.slice(1) : matches[0].values[0],
                globalMatch: null,
            };
        }
    }
    else {
        return {
            singleMatch: null,
            globalMatch: null,
        };
    }
}
function getStringRegexMatchOrCaptures(value, stringRegex, passedRegex = null) {
    const regex = passedRegex === null ? regexParser(stringRegex) : passedRegex;
    if (regex.flags.includes("g")) {
        let match = regex.exec(value);
        let count = 0;
        const final = [];
        while (match !== null && count < 1000) {
            if (match != null) {
                if (match.length > 1) {
                    final.push({
                        hasGroups: true,
                        values: match,
                    });
                }
                else {
                    final.push({
                        hasGroups: false,
                        values: match,
                    });
                }
            }
            match = regex.exec(value);
            count++;
        }
        if (final.length > 0) {
            return final;
        }
    }
    else {
        const match = value.match(regex);
        if (match != null) {
            if (match.length > 1) {
                return [
                    {
                        hasGroups: true,
                        values: match,
                    },
                ];
            }
            return [
                {
                    hasGroups: false,
                    values: match,
                },
            ];
        }
    }
    return null;
}
function stringRegexContainsGroups(stringRegex) {
    return /\([^|]+\)/g.test(stringRegex);
}
function getFirstCaptureOrNull(regex, input) {
    const results = regex.exec(input);
    if (results != null && results.length > 1) {
        return results[1];
    }
    return null;
}
function getFirstCaptureOrSame(regex, input) {
    const results = regex.exec(input);
    if (results != null && results.length > 1) {
        return results[1];
    }
    return input;
}
export const RegexUtils = {
    stringRegexContainsGroups,
    matchStringRegex,
    matchOneStringRegex,
    getStringRegexMatches,
    getStringRegexMatchOrCaptures,
    getFirstCaptureOrNull,
    getFirstCaptureOrSame,
};
